/**
 * InfoPanel — compact chips sliding out from the pinned `i` button.
 *
 * Mirrors PhotoViewer InfoPanel (Figma `40000026:13238`).
 *   - chip 1: quality (480p / 720p)
 *   - chip 2: aspect ratio (e.g. «9:16»)
 *   - chip 3: duration (e.g. «5s»)
 * Geometry and styling are shared with PhotoViewer.
 */
import { ViewerInfoChip, ViewerInfoPanel } from '../ViewerInfoChips';

function videoQualityLabel(quality) {
  const value = typeof quality === 'string' ? quality.toUpperCase() : '';
  if (value === 'LQ' || value === '480P' || value === 'Q_480P') return '480p';
  if (value === 'MQ' || value === '720P' || value === 'Q_720P') return '720p';
  return quality || null;
}

export default function InfoPanel({ item, onClose }) {
  const { aspectRatio, quality, durationSec, duration } = item || {};
  const qualityLabel = videoQualityLabel(quality);
  const durSec = durationSec ?? duration;
  const durationLabel = Number(durSec) > 0 ? `${durSec}s` : null;

  return (
    <ViewerInfoPanel onClose={onClose}>
      {qualityLabel && (
        <ViewerInfoChip data-testid="chip-quality">{qualityLabel}</ViewerInfoChip>
      )}
      {aspectRatio && (
        <ViewerInfoChip data-testid="chip-ratio">{aspectRatio}</ViewerInfoChip>
      )}
      {durationLabel && (
        <ViewerInfoChip data-testid="chip-duration">{durationLabel}</ViewerInfoChip>
      )}
    </ViewerInfoPanel>
  );
}
